import React from 'react';
import Button from '@material-ui/core/Button';
import { Link } from 'react-router-dom'
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faEllipsisV } from "@fortawesome/free-solid-svg-icons"
import {
  usePopupState,
  bindTrigger,
  bindMenu,
} from 'material-ui-popup-state/hooks'


function MobileNavigation(props) {
  const popupState = usePopupState({ variant: 'popover', popupId: 'demoMenu' })
  return (
        <React.Fragment>
          <Button id="mobileNavigationButton" {...bindTrigger(popupState)}>
          <FontAwesomeIcon className="menu" color="#fffb" icon={faEllipsisV} />
      </Button>
          <Menu {...bindMenu(popupState)}>
          <Link to='/work' id="hover2" onClick={()=>props.prop()}>
            <MenuItem onClick={popupState.close}>
              Our Work
            </MenuItem>
            </Link>
            <Link to='/blogs' id="hover2">
              <MenuItem onClick={popupState.close}>
              Writer’s Niche
            </MenuItem >
            </Link>
            <Link to='/auditions-2022' id="hover2">
              <MenuItem onClick={popupState.close}>
              Auditions
            </MenuItem >
            </Link>
          </Menu>
        </React.Fragment>
  );
}


export default MobileNavigation;
